import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import CloudinaryImage from "@/components/cloudinary-image";
import { Button } from "@/components/ui/button";

import type { RelatedCityType } from "../types";

interface CityCardProps {
  city: RelatedCityType;
}

export default function CityCard({
  city: { attributes: city },
}: CityCardProps) {
  const imageId = useMemo(() => {
    if (!city.cardImage.data?.attributes.url) {
      return null;
    }

    const { pathname } = new URL(city.cardImage.data.attributes.url);
    return `cms${pathname}`;
  }, [city]);

  return (
    <div
      className="relative w-[79%] shrink-0 overflow-hidden rounded-[30px] bg-eerie-black md:w-[261px]"
      data-id={city.slug}
    >
      <div className="aspect-[261/252]">
        {imageId && (
          <CloudinaryImage
            alt={city.nameShort}
            className="size-full"
            imageId={imageId}
            rW={600}
          />
        )}
      </div>
      <div className="flex flex-col items-center gap-4 p-6">
        <h4 className="line-clamp-1 text-center font-semibold text-20/[1.5em]">
          {city.nameShort}
        </h4>
        <Button
          asChild
          className="link-overlay h-[50px] w-[143px] rounded-[25px]"
          variant="cta"
        >
          <Link to={`/city/${city.slug}`}>View city</Link>
        </Button>
      </div>
    </div>
  );
}
